<div #firstParent class="canvas h-100">
    <div class="canvas-container h-100" #canvasContainer>
        <canvas #canvas></canvas>
    </div>

    <div class="simulation-layout d-flex flex-column gap-3">
        <button mat-fab class="simulation-layout__button"
            [class.simulation-layout__button--active]="simOverview.isOverviewActive"
            aria-label="Simulation Button" matTooltip="Show Simulation Popup" matTooltipPosition="above"
            (click)="simOverview.toggle()">
            <span class="material-symbols-outlined d-flex justify-content-center align-items-center">chart_data</span>
        </button>

        <button mat-fab class="simulation-layout__button"
            [class.simulation-layout__button--active]="isSimulationReportDialogOpen()"
            aria-label="Report Button" matTooltip="Show Report" [disabled]="!simulationReturnValues"
            matTooltipPosition="above" (click)="simOverview.openSimulationReportDialog()">
            <mat-icon>article</mat-icon>
        </button>
        <button mat-fab class="simulation-layout__button"
            [class.simulation-layout__button--active]="isSimulationGraphDialogOpen()"
            aria-label="Graph Button" matTooltip="Show Graph" [disabled]="!simulationReturnValues"
            matTooltipPosition="above" (click)="showSimulationGraph()">
            <mat-icon>insert_chart</mat-icon>
        </button>
    </div>

    <simulation-overview #simOverview [currentShapeFocus]="currentFocus" [dataViewer]="this"></simulation-overview>
    
    <div class="d-flex global-info pe-none">
        <div class="w-100 h-100 position-relative">
            @if (currentSimulationHeaderValues.length) {
                <global-metrics class="flex-grow-1" [metrics]="currentSimulationHeaderValues"></global-metrics>
            }
        </div>
    </div>
</div>
<center-canvas [centerAction]="fitBoxesWithCamera"></center-canvas>
<data-view-actions [mainComponent]="appComponent" [dataViewer]="this" [currentTabType]="TabType.SIMULATION"></data-view-actions>
@if (isLoading) {
    <div class="h-100 d-flex justify-content-center align-items-center loading">
        <mat-progress-spinner mode="indeterminate"> </mat-progress-spinner>
    </div>
}
